import { Toaster } from "components";

import { invoicesConstants } from '../constants';

import { func_validation, func_serviceHandling, isNotNullUndefined, isDateValid } from 'functions';

import { promiseInstance_authorization } from './config';
import moment from "moment";



export const invoicesActions = {
	getInvoiceList,

	generateAppendix,
	generateInvoice,
	postToSQLAccount,
	postCreditNote,
	sendEmail,
	deleteInvoice,
};

function getInvoiceList(pageNo, pageSize, sort, filterOptions) {
    return dispatch => {
		dispatch(request());

		let isOffsetValid = func_validation.isNumberValid(pageNo) && func_validation.isNumberValid(pageSize);
		let offset = isOffsetValid? pageNo * pageSize:0;

		let filterOptions__validated = isNotNullUndefined(filterOptions)? filterOptions:{};

		let paramObj = {
			offset,
			limit: pageSize,
			...filterOptions__validated,
		}

		let url = func_serviceHandling.createUrlWithParams('/Invoice/Search', paramObj)

		promiseInstance_authorization(dispatch, request, (axios) => {
			axios.get(url)
				.then(function (details) {
					// handle success
					dispatch(success(details));
				})
				.catch(function (error) {
					// handle error
					dispatch(failure(error));
				})
				.finally(function () {
					// always executed
				});
		})
    }

    function request(details) { return { type: invoicesConstants.getInvoiceList_request, details }; }
    function success(details) { return { type: invoicesConstants.getInvoiceList_success, details }; }
    function failure(error) { return { type: invoicesConstants.getInvoiceList_failure, error }; }
}

function generateAppendix(accountCode, datetime) {
    return dispatch => {
		dispatch(request());
		
		let paramObj = {
			accountCode,
			month: isDateValid(datetime) && (moment(datetime).month() + 1),
			year: isDateValid(datetime) && moment(datetime).year(),
		}

		let url = func_serviceHandling.createUrlWithParams('/Invoice/GetAppendixByAccCode', paramObj)
		
        promiseInstance_authorization(dispatch, request, (axios) => {
			axios.post(url)
				.then(function (details) {
					// handle success
					dispatch(success(details));
					Toaster({ type: "success", msg: "Successfully generated appendix"});
				})
				.catch(function (error) {
					// handle error
					dispatch(failure(error));

					let msg = error?.response?.data?.exceptionMessage? error.response.data.exceptionMessage: "Failed to generate appendix";
					Toaster({ type: "error", msg });
				})
				.finally(function () {
					// always executed
				});
		})
    }

    function request(details) { return { type: invoicesConstants.generateAppendix_request, details }; }
    function success(details) { return { type: invoicesConstants.generateAppendix_success, details }; }
    function failure(error) { return { type: invoicesConstants.generateAppendix_failure, error }; }
}

function generateInvoice(accountCode, datetime) {
    return dispatch => {
		dispatch(request());
		
		let accountCode_formatted = "";
		if (func_validation.isStringTrimNotEmpty(accountCode)) accountCode_formatted = encodeURI(accountCode);

		let datetime_formatted = "";
		if (func_validation.isDateValid(datetime)) datetime_formatted = encodeURI(datetime);

        promiseInstance_authorization(dispatch, request, (axios) => {
			axios.post('/Invoice/GenerateUnbilledInvoice/' + accountCode_formatted + "?dateBillDate=" + datetime_formatted)
				.then(function (details) {
					// handle success
					dispatch(success(details));
					Toaster({ type: "success", msg: "Successfully generated invoice"});
				})
				.catch(function (error) {
					// handle error
					dispatch(failure(error));

					let msg = error?.response?.data?.exceptionMessage? error.response.data.exceptionMessage: "Failed to generate invoice";
					Toaster({ type: "error", msg });
				})
				.finally(function () {
					// always executed
				});
		})
    }

    function request(details) { return { type: invoicesConstants.generateInvoice_request, details }; }
    function success(details) { return { type: invoicesConstants.generateInvoice_success, details }; }
    function failure(error) { return { type: invoicesConstants.generateInvoice_failure, error }; }
}

function postToSQLAccount(invoiceId) {
    return dispatch => {
		dispatch(request());
		
		let invoiceId_formatted = "";
		if (func_validation.isStringTrimNotEmpty(invoiceId) || 
			func_validation.isNumberValid(invoiceId)) 
			invoiceId_formatted = encodeURI(invoiceId);
		
        promiseInstance_authorization(dispatch, request, (axios) => {
			axios.post('/Invoice/' + invoiceId_formatted + '/PostToNetsuite')
				.then(function (details) {
					// handle success
					dispatch(success(details));
					Toaster({ type: "success", msg: `Successfully posted Reference Document No ${ details?.data?.ReferenceDocumentNo}`});
				})
				.catch(function (error) {
					// handle error
					dispatch(failure(error));

					let msg = error?.response?.data?.exceptionMessage? error.response.data.exceptionMessage: "Failed to post to SQL Account";
					Toaster({ type: "error", msg });
				})
				.finally(function () {
					// always executed
				});
		})
    }

    function request(details) { return { type: invoicesConstants.postToSQLAccount_request, details }; }
    function success(details) { return { type: invoicesConstants.postToSQLAccount_success, details }; }
    function failure(error) { return { type: invoicesConstants.postToSQLAccount_failure, error }; }
}


function postCreditNote(invoiceId) {
    return dispatch => {
		dispatch(request());
		
		let invoiceId_formatted = "";
		if (func_validation.isStringTrimNotEmpty(invoiceId) || 
			func_validation.isNumberValid(invoiceId)) 
			invoiceId_formatted = encodeURI(invoiceId);

        promiseInstance_authorization(dispatch, request, (axios) => {
			axios.post('/Invoice/PostCreditNote?id=' + invoiceId_formatted)
				.then(function (details) {
					// handle success
					dispatch(success(details));
					Toaster({ type: "success", msg: "Successfully posted credit note"});
				})
				.catch(function (error) {
					// handle error
					dispatch(failure(error));

					let msg = error?.response?.data?.exceptionMessage? error.response.data.exceptionMessage: "Failed to post credit note";
					Toaster({ type: "error", msg });
				})
				.finally(function () {
					// always executed
				});
		})
    }

    function request(details) { return { type: invoicesConstants.postCreditNote_request, details }; }
    function success(details) { return { type: invoicesConstants.postCreditNote_success, details }; }
    function failure(error) { return { type: invoicesConstants.postCreditNote_failure, error }; }
}

function sendEmail(invoiceId, isSentToCustomers) {
    return dispatch => {
		dispatch(request());
		
		let invoiceId_formatted = "";
		if (func_validation.isStringTrimNotEmpty(invoiceId) || 
			func_validation.isNumberValid(invoiceId)) 
			invoiceId_formatted = encodeURI(invoiceId);

		let queryString = "";
		if (isSentToCustomers) queryString = "?sendToCustomer=true";

        promiseInstance_authorization(dispatch, request, (axios) => {
			axios.post('/Invoice/' + invoiceId_formatted + '/SendEmail' + queryString)
				.then(function (details) {
					// handle success
					dispatch(success(details));
					Toaster({ type: "success", msg: "Successfully sent email"});
				})
				.catch(function (error) {
					// handle error
					dispatch(failure(error));

					let msg = error?.response?.data?.exceptionMessage? error.response.data.exceptionMessage: "Failed to send email";
					Toaster({ type: "error", msg });
				})
				.finally(function () {
					// always executed
				});
		})
    }

    function request(details) { return { type: invoicesConstants.sendEmail_request, details }; }
    function success(details) { return { type: invoicesConstants.sendEmail_success, details }; }
    function failure(error) { return { type: invoicesConstants.sendEmail_failure, error }; }
}

function deleteInvoice(invoiceId) {
    return dispatch => {
		dispatch(request());
		
		let invoiceId_formatted = "";
		if (func_validation.isStringTrimNotEmpty(invoiceId) || 
			func_validation.isNumberValid(invoiceId)) 
			invoiceId_formatted = encodeURI(invoiceId);

        promiseInstance_authorization(dispatch, request, (axios) => {
			axios.delete('/Invoice/' + invoiceId_formatted)
				.then(function (details) {
					// handle success
					dispatch(success(details));
					Toaster({ type: "success", msg: "Successfully deleted invoice"});
				})
				.catch(function (error) {
					// handle error
					dispatch(failure(error));

					let msg = error?.response?.data?.exceptionMessage? error.response.data.exceptionMessage: "Failed to delete invoice";
					Toaster({ type: "error", msg });
				})
				.finally(function () {
					// always executed
				});
		})
    }

    function request(details) { return { type: invoicesConstants.deleteInvoice_request, details }; }
    function success(details) { return { type: invoicesConstants.deleteInvoice_success, details }; }
    function failure(error) { return { type: invoicesConstants.deleteInvoice_failure, error }; }
}